module.exports = __webpack_public_path__ + "media/images/country_flags/gt-ff2a3c6ecb22f9975d794d67e2856b50.png";